// User helpers + constants
export const ROLES = {
  founder:     { label: 'Founder', color: '#2EA3F2' },
  contributor: { label: 'Editor',  color: '#34D399' },
  client:      { label: 'Client',  color: '#EC4899' },
};

export const STAGES = {
  todo:        { id: 'todo',        label: 'À faire',  color: '#8A9DB8', pill: 'pill-todo' },
  in_progress: { id: 'in_progress', label: 'En cours', color: '#2EA3F2', pill: 'pill-in-progress' },
  review:      { id: 'review',      label: 'À valider',color: '#F5A623', pill: 'pill-review' },
  // Iter 62fk — "À poster" : vidéo déjà montée, prête à être publiée.
  to_post:     { id: 'to_post',     label: 'À poster', color: '#F5C56A', pill: 'pill-to-post' },
  done:        { id: 'done',        label: 'Terminé',  color: '#34D399', pill: 'pill-done' },
};

export const STAGE_ORDER = ['todo', 'in_progress', 'review', 'to_post', 'done'];

export const PRIORITIES = {
  low:    { label: 'Basse',  color: '#8A9DB8' },
  medium: { label: 'Moyenne',color: '#F5A623' },
  high:   { label: 'Haute',  color: '#FF6B6B' },
};

// Iter47x — 4 category tags for Rayan's chef-monteur planning
// Colors + default time slots based on the "trame de journée" (fixed daily schedule)
export const CATEGORY_TAGS = {
  correction_monteur: {
    id: 'correction_monteur',
    label: 'Correction Monteur',
    short: 'Corr. Monteur',
    color: '#FBBF24',       // JAUNE
    bg: 'rgba(251,191,36,0.14)',
    border: 'rgba(251,191,36,0.45)',
    defaultStart: '09:30',
    defaultEnd: '09:45',
  },
  correction_montage: {
    id: 'correction_montage',
    label: 'Correction Montage',
    short: 'Corr. Montage',
    color: '#F472B6',       // ROSE
    bg: 'rgba(244,114,182,0.14)',
    border: 'rgba(244,114,182,0.45)',
    defaultStart: '09:45',
    defaultEnd: '10:30',
  },
  montage: {
    id: 'montage',
    label: 'Montage',
    short: 'Montage',
    color: '#F5A623',       // ORANGE
    bg: 'rgba(245,166,35,0.14)',
    border: 'rgba(245,166,35,0.45)',
    defaultStart: '10:30',
    defaultEnd: '16:00',
  },
  developpement: {
    id: 'developpement',
    label: 'Développement',
    short: 'Dév.',
    color: '#A78BFA',       // VIOLET
    bg: 'rgba(167,139,250,0.14)',
    border: 'rgba(167,139,250,0.45)',
    defaultStart: '18:00',
    defaultEnd: '20:00',
  },
  // Iter60d — founder-only tags (Rayan / Hugo assign to themselves)
  expansion: {
    id: 'expansion',
    label: 'Expansion',
    short: 'Expansion',
    color: '#5BBEFC',
    bg: 'rgba(91,190,252,0.14)',
    border: 'rgba(91,190,252,0.45)',
  },
  delivery: {
    id: 'delivery',
    label: 'Delivery',
    short: 'Delivery',
    color: '#34D399',
    bg: 'rgba(52,211,153,0.14)',
    border: 'rgba(52,211,153,0.45)',
  },
};

export const CATEGORY_TAG_ORDER = ['correction_monteur', 'correction_montage', 'montage', 'developpement'];
export const FOUNDER_TAG_ORDER = ['expansion', 'delivery'];
// Axel (chef monteur) never sees the "developpement" tag in his personal view
// Iter61p — Ancien filtre spécifique Axel retiré : Axel doit voir toutes les catégories,
// y compris "Développement" (demande utilisateur du 2026-02-16).
export const AXEL_HIDDEN_TAGS = [];



export const FOLDER_LABELS = {
  internal: 'Interne',
  creative: 'Creative',
  strategy: 'Strategy',
  finance:  'Finance',
  legal:    'Legal',
  ops:      'Ops',
  verbe:    'Verbe',
  brief:    'Brief client',
  cr:       'Compte-rendu',
  idees:    'Idées / Script',
};

export const folderLabel = (f) => FOLDER_LABELS[f] || (f ? f.charAt(0).toUpperCase() + f.slice(1) : 'Interne');

export const KNOWN_FOLDERS = ['internal', 'verbe', 'brief', 'cr', 'idees', 'creative', 'strategy', 'finance', 'legal', 'ops'];

// ASA Note templates (Google-Docs style starter content)
export const NOTE_TEMPLATES = [
  {
    id: 'verbe',
    title: 'Verbe',
    folder: 'verbe',
    accent: '#5BBEFC',
    description: 'Ton de la marque · vocabulaire · interdits',
    content: `<h1>Verbe</h1>
<p><em>Comment la marque parle.</em></p>
<h2>Ton</h2>
<ul><li>Posture :</li><li>Énergie :</li><li>Émotion dominante :</li></ul>
<h2>Vocabulaire</h2>
<ul><li>Mots à utiliser :</li><li>Mots à éviter :</li></ul>
<h2>Exemples</h2>
<blockquote>Phrase modèle…</blockquote>`,
  },
  {
    id: 'brief',
    title: 'Brief client',
    folder: 'brief',
    accent: '#A78BFA',
    description: 'Contexte · objectifs · livrables · deadlines',
    content: `<h1>Brief client</h1>
<h2>Client</h2><p>—</p>
<h2>Contexte</h2><p>—</p>
<h2>Objectifs</h2><ul><li></li></ul>
<h2>Cible</h2><p>—</p>
<h2>Livrables</h2><ul><li></li></ul>
<h2>Deadlines</h2><ul><li></li></ul>
<h2>Références</h2><ul><li></li></ul>`,
  },
  {
    id: 'cr',
    title: 'Compte-rendu',
    folder: 'cr',
    accent: '#34D399',
    description: 'Réunion · décisions · actions',
    content: `<h1>Compte-rendu — [Sujet]</h1>
<p><strong>Date :</strong> · <strong>Présents :</strong></p>
<h2>Ordre du jour</h2><ol><li></li></ol>
<h2>Décisions</h2><ul><li></li></ul>
<h2>Actions</h2><ul><li>[ ] Action — @qui — pour le …</li></ul>
<h2>Notes</h2><p>—</p>`,
  },
  {
    id: 'idees',
    title: 'Idées / Script',
    folder: 'idees',
    accent: '#F5A623',
    description: 'Brainstorm · accroches · structure',
    content: `<h1>Idées / Script</h1>
<h2>Accroche (3 sec)</h2><ul><li></li></ul>
<h2>Promesse</h2><p>—</p>
<h2>Structure</h2><ol><li>Hook</li><li>Contexte</li><li>Tension</li><li>Révélation</li><li>CTA</li></ol>
<h2>Notes voix-off</h2><p>—</p>`,
  },
];

// File icon by mime/extension
export const fileIcon = (mime, name = '') => {
  const m = (mime || '').toLowerCase();
  const ext = name.split('.').pop()?.toLowerCase() || '';
  if (m.includes('pdf') || ext === 'pdf') return 'file-text';
  if (m.startsWith('image')) return 'image';
  if (m.startsWith('video')) return 'film';
  if (m.startsWith('audio')) return 'music';
  if (['doc','docx'].includes(ext)) return 'file-text';
  if (['xls','xlsx','csv'].includes(ext)) return 'sheet';
  if (['zip','rar','7z'].includes(ext)) return 'archive';
  return 'file';
};

export const formatSize = (bytes = 0) => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
};

export const formatRelative = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60)    return "À l'instant";
  if (diff < 3600)  return `${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h`;
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
};

export const initials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

export const stripHtml = (html = '') =>
  html.replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
